/* eslint-disable no-param-reassign */
import extend from 'lodash/extend';

import ProductType from 'bundles/payments/common/ProductType';
import createCartPromise from 'bundles/payments/promises/createCart';

/**
 * Create a Specialization Cart. NOTE: Refer to ./createCart for more information.
 * @param {string} id - The productItemId
 * @param {Object} options - Refer to ./createCart
 * @param {Array} options.auxiliaryCartInfo - Refer to ./createCart
 * @param {Boolean} skipWelcomeEmail - Whether to skip the s12n welcome email
 * @returns {Promise.<Object>} ./createCart response.
 */
export default function (id: string, options = {}, skipWelcomeEmail: boolean) {
  options = extend(
    {},
    {
      productItems: [
        {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'productType' does not exist on type '{}'... Remove this comment to see the full error message
          productType: options.productType || ProductType.SPECIALIZATION,
          productItemId: id,
          productAction: 'Buy',
          ...(skipWelcomeEmail
            ? {
                metadata: {
                  'org.coursera.payment.SpecializationSubscriptionCartItemMetadata': {
                    skipWelcomeEmail: true,
                  },
                },
              }
            : {}),
          cartItemIdToRefund: {},
        },
      ],
    },
    options
  );

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{}' is not assignable to paramet... Remove this comment to see the full error message
  return createCartPromise(options);
}
